import * as Errors from "../../shared/node/Errors";

import {
  CreateBookingsWithUnpaidInvoiceDocument,
  CreateBookingsWithUnpaidInvoiceMutation,
  CreateBookingsWithUnpaidInvoiceMutationVariables,
} from "../GeneratedGraphQL";
import {
  successConfirmBookingId,
  successReservedSpaceId,
} from "./createBookingsForBookingTool";

import { defaultBookingTool } from "./bookingTool";
import { defaultOrganisation } from "./organisation";
import { format } from "date-fns";
import { getBookingQuestionInput } from "../utils";
import { GraphQLError } from "graphql";
import { MockedResponse } from "@apollo/client/testing";
import { today } from "../utils/today";
import { UserDetails } from "../AppDataProvider/types";
import { userDetailsStripeInvoice } from "./userDetails";

const timezone = "Europe/London";

const userDetails: UserDetails = {
  email: "eab@appointedd.com",
  firstName: "Eric",
  lastName: "Blair",
  marketingOptIn: false,
  phone: "+441234567890",
};

const successRequestVariables: CreateBookingsWithUnpaidInvoiceMutationVariables =
  {
    bookings: [
      {
        bookingNotes: "Unpaid invoice notes",
        bookingQuestions: getBookingQuestionInput({
          bookingQuestionData: {},
          bookingQuestions: defaultOrganisation.externalBookingQuestions,
        }),
        customer: {
          ...userDetails,
          crmFieldData: [
            { id: "date_field", value: format(today, "yyyy-MM-dd") },
            { id: "optional_field", value: "" },
            { id: "text_field", value: "this is a text field" },
          ],
        },
        organisationId: defaultOrganisation._id,
        reservedSpaceId: successReservedSpaceId,
        timezone: timezone,
      },
    ],
    bookingToolId: defaultBookingTool._id,
    createdSource: "test-app",
    discount: {
      customerEmail: userDetailsStripeInvoice.email,
      discountCode: "FREE_CODE",
    },
    locale: "en-GB",
  };

export const createBookingsWithUnpaidInvoiceRequestSuccess: MockedResponse<CreateBookingsWithUnpaidInvoiceMutation> =
  {
    request: {
      query: CreateBookingsWithUnpaidInvoiceDocument,
      variables: successRequestVariables,
    },
    result: {
      data: {
        createBookingsWithUnpaidInvoice: {
          __typename: "CreateBookingsResult",
          bookings: [{ _id: successConfirmBookingId }],
        },
      },
    },
  };

export const createBookingsWithUnpaidDiscountInvoiceRequestSuccess: MockedResponse<CreateBookingsWithUnpaidInvoiceMutation> =
  {
    request: {
      query: CreateBookingsWithUnpaidInvoiceDocument,
      variables: {
        ...successRequestVariables,
        discount: {
          customerEmail: userDetailsStripeInvoice.email,
          discountCode: "TEST_CODE",
        },
      },
    },
    result: {
      data: {
        createBookingsWithUnpaidInvoice: {
          __typename: "CreateBookingsResult",
          bookings: [{ _id: successConfirmBookingId }],
        },
      },
    },
  };

export const createBookingsWithUnpaidInvoiceRequestError: MockedResponse<CreateBookingsWithUnpaidInvoiceMutation> =
  {
    request: {
      query: CreateBookingsWithUnpaidInvoiceDocument,
      variables: successRequestVariables,
    },
    result: { errors: [new GraphQLError("Unable to create booking")] },
  };

export const invalidOrAlteredCreateBookingsWithUnpaidInvoiceRequest: MockedResponse<CreateBookingsWithUnpaidInvoiceMutation> =
  {
    request: {
      query: CreateBookingsWithUnpaidInvoiceDocument,
      variables: successRequestVariables,
    },
    result: { errors: [new Errors.UserInputError("Something's changed")] },
  };
